let UTILS = require("../libs/utils.js");
var v7782;
var v7783;
var config = require("../config.js");
module.exports = {
  id: "chs",
  name: "Chaos Snipers",
  alias: "chs",
  party: true,
  tag: ["Party", "#ffac00", "#ffb600"],
  endStats: ["sid", "name", "score", "kills", "deaths", "reward"],
  leaderStats: ["score", "kills"],
  forceSpawn: 3,
  forceClass: 0,
  noPickups: true,
  noKnives: true,
  gravMlt: 0.92,
  jumpMlt: 1.5,
  groundAccel: 2,
  airAccel: 1.4,
  reloadMlt: 0.5,
  frSlid: true,
  wallJ: true,
  wallJM: 100,
  wallJD: 0.05,
  wallJV: 0.06,
  wallJYV: 2,
  maxHealth: 10,
  ammoLimit: 1,
  noScrLimit: true,
  startingLoadout: [0],
  disabledStreaks: [4, 5, 6]
};